import React from 'react';

export default function ContactListErrorState({
  title,
  message,
  primaryActionLabel,
  onPrimaryAction,
}) {
  return (
    <div className="max-w-3xl mx-auto text-center bg-amber-400/10 border border-amber-200/30 rounded-3xl px-8 py-12">
      <h2 className="text-2xl font-semibold text-amber-300 mb-4">
        {title}
      </h2>
      <p className="text-amber-100/90 mb-8">
        {message}
      </p>
      {primaryActionLabel && (
        <button
          type="button"
          onClick={onPrimaryAction}
          className="inline-flex items-center justify-center px-6 py-3 rounded-full font-semibold text-gray-900 bg-amber-300 hover:bg-amber-200 transition-colors shadow-lg shadow-amber-900/40"
        >
          {primaryActionLabel}
        </button>
      )}
    </div>
  );
}
